import { apiSlice } from "./apiSlice";

export const railSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllRail: builder.query({
            query: (params) => ({
                url: `RailAsset`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["RailTracker"],
        }),

        createRail: builder.mutation({
            query: ({ body }) => ({
                url: `RailAsset`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["RailTracker"],
        }),

        updateRail: builder.mutation({
            query: ({ body }) => ({
                url: `RailAsset`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["RailTracker"],
        }),

        getExportRail: builder.query({
            query: (params) => ({
                url: `RailAsset`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const { useLazyGetAllRailQuery, useCreateRailMutation, useUpdateRailMutation, useLazyGetExportRailQuery } = railSlice;